import { select } from "d3";
import React, { Component } from "react";
import PropTypes from "prop-types";

class HumanBody extends Component {
  static propTypes = {
    localizedData: PropTypes.array,
  };

  removeAllValueText = () => {
    select("#values").selectAll("*").remove();
  };

  applyValueText = (part, value) => {
    const path = select(part).select("path");
    if (path.node()) {
      path.style("fill", "#5D51AE").style("fill-opacity", 0.25);
      const valuesGroup = select("#values");

      // Get center of path
      const box = path.node().getBBox();
      const x = box.x + box.width / 2;
      const y = box.y + box.height / 2;

      valuesGroup
        .append("circle")
        .attr("cx", x - 10)
        .attr("cy", y - 8)
        .attr("r", "22")
        .style("fill", "#5D51AE")
        .style("fill-opacity", 0.75);

      valuesGroup
        .append("text")
        .attr("text-anchor", "middle")
        .attr("x", x - 10)
        .attr("y", y - 4)
        .attr("font-size", "8pt")
        .attr("font-weight", "bold")
        .attr("font-family", '"Roboto","Helvetica Neue",Helvetica,Arial,sans-serif')
        .attr("fill", "#ffffff")
        .text(value + "%");
    }
  };

  applyHoverEffect = (part) => {
    const path = select(part);
    if (path) {
      path
        .on("mouseover", function (d) {
          select(part)
            .select("path")
            .style("fill", "#5D51AE")
            .style("fill-opacity", 0.5);
        })
        .on("mouseout", function (d) {
          select(part)
            .select("path")
            .style("fill", "#5D51AE")
            .style("fill-opacity", 0.25);
        });
    }
  };

  componentDidMount() {
    this.updateBodyParts();
  }

  componentDidUpdate() {
    this.updateBodyParts();
  }

  updateBodyParts() {
    const { localizedData } = this.props;
    if (localizedData) {
      this.removeAllValueText();
      for (var ii = 0; ii < localizedData.length; ii++) {
        var part = localizedData[ii];
        var className = part.class;
        var percentage = part.percentage;

        this.applyHoverEffect("#" + className);
        this.applyValueText("#" + className, percentage);
      }
    }
  }

  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="500 -30 400 800"
        id="human-body"
        height="100%"
        width="100%"
      >
        <g id="Layer_1">
          <g id="right-leg">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M671.2,408.8c-.4,1.7-.7,3.4-1,5.1-2.7,15.4-4.8,30.7-7.8,46.1-2.9,14.1-4.6,28.5-5.1,42.9,0,11.5-2,23-5.7,33.9-3,8.5-5.3,17-4.5,26.3.8,9.6,2.4,19.4,1.1,28.7-3.3,22.5-7.7,45-12.7,67.2-3.1,13.8-5.1,28.3-4.6,42.2h0s-10.9-7.1-24.4,1c4.8-11.6,3.8-24.3,3.4-36.8-.6-13.5-3.5-26.9-4.8-40.3-1.4-14.3-2.7-28.6-3.1-42.9-.2-9.9.3-19.9,4.2-29.4,1.8-4.5,3.7-9.3,3.7-14.1,0-15.6-.2-31.2-1.3-46.7-1.2-17.3-3.1-34.6-5-51.8-1.5-14.1-1.8-36-.9-55.6,0,0,21,29.9,68.6,24.3h-.1Z"
            />
          </g>
          <g id="abdomen">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M748,328.4c-1.2.7-69.7,38.2-136.7.3,5.6-21.8,12.6-48.6,12.1-55.9,12.5-16.2,54.9-27.4,54.9-27.4,0,0,53.1,14,57,27.4,1.3,9.8,8,33.5,12.7,55.6Z"
            />
          </g>
          <g id="chest">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M741.2,221.6c-5.8,3.1-7,42.4-5.9,51.2-3.9-13.5-57-27.4-57-27.4,0,0-42.4,11.2-54.9,27.4-.9-12.7.3-39.7-8.4-51.5-17.3-59.9-3.4-91.4-3.4-91.4,29.2-6.6,64.9,13.7,67.6,13.2,5.6-1.2,47.5-18.8,64.6-10.5l.6.3s14.9,34-3.4,88.7h.2Z"
            />
          </g>
          <g id="genitals">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M753.8,384.6h0c-.6,1.5-11.5,24.9-71.7,24.9-.6-3.6-1.2-7.3-1.8-10.9-.3-1.6-2-3-3.1-4.5-1.1,1.3-2.7,2.4-3.1,3.8-1,3.6-2,7.2-2.8,10.8-47.7,5.7-68.6-24.2-68.6-24.2.5-11.1,1.4-21.6,2.6-29.4.8-5.1,3.2-15,6.1-26.3,67,37.9,135.5.3,136.7-.3,2.5,11.5,4.4,22.5,4.6,31,1,8.4,1.4,16.8,1.1,25.3v-.2Z"
            />
          </g>
          <g id="mouth">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M707.3,66.1c-1.6-2.6-2.7,8.2-3.7,11.3l-.3.8s-13.3,15.9-20.7,17.7c-4.1,1-5,1-6.8.7-2.7-.5-11-4.7-21.4-18.4-.3-.7-.5-1.4-.8-2.1-1.2-2.6-2.6-12.1-4.2-9.7,3.3-2.7,13.7-10.5,29.1-10.9,11.6-.3,24.7,8,28.6,10.2"
            />
          </g>
          <g id="face">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M714.3,49.9c-.8-6.1-5.2-2.7-7,0,3.1-6.1,2.5-14.9,1.9-21.1-1.6-16.8-13.5-28.8-31.4-28.8s-30.3,24-30.1,30.9c0,1.6-.3,14.1,1.6,19-3.2-4.7-5.8-3.4-6.6-2-1.4,5.6,1.4,13.4,3,16.5.9,1.7,3.2,3.4,4.2,2,0,0,.2-.2.3-.3h-.3c-.2,0-.3.3-.4.4.2-.2.3-.3.4-.4,3.7-2.9,13.9-10.2,28.7-10.5,11.5-.2,24.5,7.9,28.5,10.2h0c.2-.2.5,0,.7.3,1.6,2.6,3.1.4,3.9-1.7,1.5-4.1,3.1-10.3,2.5-14.6h0Z"
            />
          </g>
          <g id="larynx">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M744,132.6c-17.1-8.3-59.1,9.3-64.6,10.5-2.8.6-38.5-19.7-67.6-13.2,10.8-2.8,21-7.4,30.2-13.7,5-3.5,11.5-7.7,13-12.8,2.4-8,3-16.9,0-25.2,10.5,13.7,18.8,17.8,21.4,18.4,1.8.4,2.7.4,6.8-.7,7.4-1.8,20.7-17.7,20.7-17.7-2.9,8.9-5.6,17.9.8,26.6,1.7,2.3,2.9,5.4,5.2,6.9,9.6,6.5,19.1,13.3,29.4,18.5,1.6.8,3.1,1.5,4.7,2.4h0Z"
            />
          </g>
          <g id="left-arm">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M822.2,349.6s-15.1-2.1-21.4,11.5c-2.1-8.2-5.8-16-11-22.7-6.7-8.8-14.1-17.6-18.3-27.6-8-18.9-14.1-38.6-20.7-58.1-2.8-8.2-7.3-22.7-9.6-31.1,18.3-54.6,3.4-88.7,3.4-88.7,11.1,5.8,20.9,12.7,25.8,25.1,1.8,4.7,2.9,9.6,3.2,14.7.5,9.8,1.9,17.8,1.5,27.6,1,6.1.8,14.1,3,20.6,4.9,14.8,10.6,43.2,16,51,8,11.5,10.9,25.3,15.6,38.3,5.2,14.5,6.4,25.1,12.5,39.3h0Z"
            />
          </g>
          <g id="left-foot">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M753.4,741.8c-4.6,2.9-9.4,2.2-14.2,3.1-10.4,1.8-15.7-.7-18.4-10.9-2.4-9.2-3.4-18.7-4.5-28.2,0-1.4,0-2.9.3-4.3,6.6-5.5,15.9-6.2,23.3-1.8,1.5,6.3,4.5,12.2,8.8,17.1,3.1,3.8,6,7.8,8.4,12.1,4,6.5,2.7,8.9-3.7,13h0Z"
            />
          </g>
          <g id="left-hand">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M845.4,376.3c-1.7-.4-3.4-.7-5.1-.7.3,1.5.8,3,1.3,4.5,4,9.2,8.8,17.8,12.8,26.9.7,1.4,1.2,2.9,1.5,4.5.2,1.3-.4,2.5-1.6,3.1-1,0-1.9-.5-2.6-1.3-2.9-3.3-10.8-16.9-15.3-20.5,1.3,6.4,10,24.5,10,26.9s-.4,4.1-2.4,5.1c-1.6-.2-3-1.1-3.7-2.6-2-3.7-8.5-17.7-11.8-22.7-1.4,9.4,5.1,32-2.1,32-2.7.7-5.3-19.8-7.9-29.7-.8,2.6-1.4,5.3-1.8,8.1-1,5.5,0,14.6-3.3,16.3-4.5-1.3-3-8.6-3.2-12.2-.5-9-.6-17.8-4.3-26.3-1.7-3.8-2.2-8.4-2.6-12.8-.4-4.6-1.2-9.2-2.3-13.7,6.2-13.6,21.4-11.5,21.4-11.5,1.9,4.6,10.5,10.7,15.4,12.8,6.8,3,12.6,8.6,18.7,13.1,1.2,1.6,2,1.8,2,3.1-.9,1.5-3.2,1.5-4.4,1.1-2.9-.8-5.5-2.5-8.4-3.6h-.3Z"
            />
          </g>
          <g id="left-leg">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M751.3,575.9c.8,8.5,2.4,17.2,1.7,25.6-1.3,15.4-3.9,30.7-6.2,46.1-2,13.5-4.2,26.9-6.4,40.3-.5,3.2-1.8,6.6-1.1,9.5.2.7.3,1.5.5,2.2-7.4-4.4-16.7-3.6-23.3,1.8.4-1.5.6-3.1.8-4.6.3-2.8.3-5.5,0-8.3-2-13.5-3.9-26.9-6.4-40.3-2.9-15.4-6.8-30.7-9.3-46.1-1.4-8.4-1-12.4,1.5-25.6,1.5-6.2,1.9-7.7,1.3-11.4-2.1-12.7-4.2-25.4-7.7-37.7-2.8-9.8-4.5-19.9-5-30.1-.6-12.4-1.3-24.8-2.6-37.1s-3.3-24.3-5-36.5c-.7-4.7-1.4-9.4-2.1-14.1,60.2,0,71.1-23.4,71.7-24.9-.3,11-1.3,21.8-1.9,31.8-1.3,19.7-3.7,39.3-5.6,58.9-1,9.8-2.4,19.6-3.1,29.4-1.8,24.1,6,47.2,8.2,71h0Z"
            />
          </g>
          <g id="right-arm">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M615.1,221.4c-.9,3.8-1.8,7.7-2.6,11.5-2.4,12.6-4.1,25.3-7.2,37.7-5.6,22.2-17,41.9-27.3,62.2-6.6,13-10.1,16.6-14.1,27.9,0,0-5.6-16.1-25.3-11.7.6-.7,1.2-1.4,1.7-2.1,4.3-5.9,11.2-16.4,13.4-22.4,6.1-16.5,7.1-34.6,13.1-51.1,6.7-18.3,12.9-36.5,14.9-55.8,1.9-18.5,2.6-37.1,4-55.7,1.3-15,10.4-28.1,24.2-31.4l1.8-.4s-13.9,31.5,3.4,91.4h0Z"
            />
          </g>
          <g id="right-foot">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M625.5,736.5c-1.5,5.7-4.8,6-9.2,5.7h-3.8c-4.7-.4-9.4-.7-14.1-1.3-8.2-1-11.7-9.1-7-16,2.9-4.3,5.7-8.8,9-12.8,2.5-3,4.5-6.3,6-9.9,13.5-8.1,24.4-1,24.4-1,.5,12.4-2.2,23.6-5.3,35.3h0Z"
            />
          </g>
          <g id="right-hand">
            <path
              transform="translate(-11.95 -14.85)"
              fill="#f8f7f7"
              d="M563.9,360.6c-.6,1.8-1.3,3.8-2,6.1s-3.5,16.6-4.5,20.7c-2.9,12.8-.2,31.8-2.2,33.1-4.9,0-4.2-10.3-5.1-15.1-.4-2-.3-8.3-1-10.2-1.7,4.8-3.1,9.7-4.3,14.7-1.1,4.3-3.4,12.1-4.8,16.3-1.4,1.8-3.1,3.5-5.1.5-.2-2,2-14,2.3-15.9.9-7.5,1.6-8.5,1.6-16.6-3,6.4-9,25-10.2,28.4-.8,1.9-2.5,3.2-4.5,3.6-2.1-1.3-1.2-3.4-1.3-5.1,0-3.8,6.5-30,5.7-30.7-2,5.2-5.1,11.6-7.3,17-.9,2.5-2.4,7-5.3,6.5-3.8-2.2-2.6-4.6-1.6-7.5,3.8-11.7,7.3-23.4,11-35.2-3.2,1.8-6.2,4-9,6.4-2.7,2.5-6.7,6.8-9.5,2.2-.2-1.3,4.8-7,4.8-7,3.8-4.4,6.8-9.4,13-12.8,5.2-2.9,9.9-6.6,13.8-11,19.8-4.4,25.4,11.7,25.4,11.7h0Z"
            />
          </g>
          <g id="values" />
        </g>
      </svg>
    );
  }
}

export default HumanBody; 